import type { Components, Theme } from '@mui/material/styles';
import { fontFamily } from '@/@mui/tokens/font-family';
import { pxToRem } from '@/@mui/utils/px-to-rem';

export const MuiTab: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme: { shape, palette, breakpoints, spacing } }) => {
      return {
        minHeight: pxToRem(40),
        border: `1px solid ${palette.neutral.darker}`,
        color: palette.neutral.darker,
        fontFamily: fontFamily.fontFamilyCarbona,
        fontWeight: 600,
        textTransform: 'none',
        padding: spacing(1.3, 2),
        backgroundColor: palette.background.paper,

        '&.Mui-selected': {
          border: `1px solid ${palette.primary.dark}`,
          backgroundColor: palette.primary.light,
          color: palette.primary.dark,
        },
        '&:first-of-type': {
          borderTopLeftRadius: shape.borderRadius,
          borderBottomLeftRadius: shape.borderRadius,
        },
        '&:last-of-type': {
          borderTopRightRadius: shape.borderRadius,
          borderBottomRightRadius: shape.borderRadius,
        },
        '&:not(:first-of-type)': {
          borderLeft: 'none',
        },
        [breakpoints.down('sm')]: { flex: 1 },
      };
    },
  },
};
